import { BookOpenCheckIcon, CalendarCheckIcon, FileTextIcon, FolderOpenIcon, ListChecksIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type BonusGroup = {
  label: string;
  items: string[];
};

export type Bonus = {
  number: string;
  title: string;
  description: string;
  items?: string[];
  groups?: BonusGroup[];
  cycle?: string[];
  benefit?: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Drilling & Well Engineering Classroom Activities & Challenges',
    description:
      '150 ready-to-use activity ideas covering drilling fundamentals, well lifecycle concepts, geology and well planning, rig systems and equipment, drilling fluids, circulation and hole cleaning, casing and cementing, well construction, completion and production, pressure concepts, well control, operational safety, drilling performance, troubleshooting, engineering reasoning, technical communication, risk awareness, and integrated well engineering. Organized by difficulty level and topic.',
    benefit: 'Materials already designed for your classroom: saves hours every quarter.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Drilling & Well Engineering Teacher Assessment Kit',
    description:
      'Comprehensive assessment resources designed to evaluate student learning throughout a drilling and well engineering course. Includes:',
    items: [
      'Foundational level assessments',
      'Intermediate level assessments',
      'Advanced level assessments',
      'Concept-understanding questions',
      'Technical reasoning questions',
      'Scenario-based assessments',
      'Application-focused questions',
      'Well-system understanding checks',
      'Drilling-operation assessments',
      'Well construction assessments',
      'Completion and production assessments',
      'Pressure and well-control assessments',
      'Troubleshooting assessments',
      'Risk and safety questions',
      'Integrated engineering assessments',
      'Teacher guidance',
    ],
    benefit: 'Never build an exam from scratch under pressure again.',
    value: 'USD 14',
    icon: ListChecksIcon,
  },
  {
    number: '03',
    title: '100 Drilling & Well Engineering Case Studies & Problem-Solving Scenarios',
    description:
      'A collection of 100 developed drilling and well engineering cases involving well planning, geology and subsurface conditions, rig systems, drilling equipment, drilling fluids, circulation, well construction, casing and cementing, completion and production, pressure and well control, drilling performance, operational problems, troubleshooting, risk and safety, and integrated well engineering challenges.',
    benefit:
      'Students analyze facts, separate known information from assumptions, identify missing evidence, and develop justified technical solutions.',
    value: 'USD 14',
    icon: FileTextIcon,
  },
  {
    number: '04',
    title: 'Drilling & Well Engineering Teacher Dictionary: 200 Essential Concepts Explained',
    description:
      'Comprehensive reference handbook covering 200 essential drilling and well engineering concepts designed to help teachers explain vocabulary and concepts clearly. Includes terminology related to:',
    items: [
      'Drilling Fundamentals',
      'Well Planning',
      'Geology',
      'Rig Equipment',
      'Drilling Fluids',
      'Well Construction',
      'Completion',
      'Production',
      'Pressure',
      'Well Control',
      'Troubleshooting',
      'Engineering Reasoning',
      'Well Integrity',
      'Operational Risk',
      'Data Quality',
      'Reliability',
      'Human-System Interaction',
      'Technical Communication',
      'Multidisciplinary Reasoning',
    ],
    benefit: 'Project it in class and your students instantly understand complex drilling and well engineering concepts.',
    value: 'USD 14',
    icon: BookOpenCheckIcon,
  },
  {
    number: '05',
    title: 'Drilling & Well Engineering Teacher Lesson Planning Guide',
    description:
      'A complete planning resource designed to help educators turn technical material into organized lessons. Includes 30 Ready-to-Use Lesson Structures.',
    groups: [
      {
        label: 'Organized into six teaching blocks:',
        items: [
          'BLOCK 1 — Foundations & Well Planning',
          'BLOCK 2 — Rigs & Drilling Systems',
          'BLOCK 3 — Drilling Fluids & Well Construction',
          'BLOCK 4 — Completion & Production',
          'BLOCK 5 — Pressure, Well Control & Safety',
          'BLOCK 6 — Performance & Engineering Reasoning',
        ],
      },
      {
        label: 'Each lesson structure includes:',
        items: [
          'Learning Objectives',
          'Key Concepts',
          'Lesson Opening',
          'Core Explanation',
          'Guided Classroom Task',
          'Student Questions',
          'Understanding Check',
          'Common Misconceptions',
          'Lesson Connections',
        ],
      },
    ],
    cycle: ['Plan', 'Introduce', 'Explain', 'Connect', 'Apply', 'Question', 'Assess', 'Review', 'Integrate'],
    value: 'USD 14',
    icon: CalendarCheckIcon,
    wide: true,
  },
];
